import { render, staticRenderFns } from "./AppCardFooter.vue?vue&type=template&id=3218a67e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppCardFooter.vue"
export default component.exports